import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CrownFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="crownFilled" ref={ref} {...props}>
      <path d="M21.38,7.75a.74.74,0,0,0-.84,0L17.73,9.54,16,5.19a.76.76,0,0,0-.59-.46A.74.74,0,0,0,14.7,5L12,8.32,9.31,5a.74.74,0,0,0-.69-.27A.76.76,0,0,0,8,5.19L6.28,9.54,3.47,7.73a.75.75,0,0,0-1.13.8l2,8.45v0c.26,2.06,5.38,2.29,7.62,2.29s7.37-.23,7.63-2.29v0l2-8.45A.74.74,0,0,0,21.38,7.75ZM12,17.79c-3.65,0-5.68-.6-6.1-1,.47-.55,3.13-1.49,6.1-1.49s5.64.94,6.11,1.49C17.69,17.19,15.66,17.79,12,17.79Z" />
    </Icon>
  ),
) as IconWithRender;

CrownFilledIcon.displayName = 'CrownFilledIcon';
CrownFilledIcon.renderIcon = (props) => <CrownFilledIcon {...props} />;
export default CrownFilledIcon;
